function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import { guid } from '@okee-uikit/react-utils';
import { Emitter } from '@okee-uikit/react-hooks';
import ReactDOM from 'react-dom';
import { RcNotificationContainer } from '../components/RcNotificationContainer';
import { NotificationContext } from '../context/notification';
export var NotificationInstance = function (_Emitter) {
  _inherits(NotificationInstance, _Emitter);

  var _super = _createSuper(NotificationInstance);

  function NotificationInstance(conf) {
    var _this;

    _classCallCheck(this, NotificationInstance);

    _this = _super.call(this);
    _this.notices = [];
    _this.container = typeof window !== 'undefined' ? document.createElement('div') : null;
    _this.mounted = false;
    _this.disposed = false;
    var _conf$maxCount = conf.maxCount,
        maxCount = _conf$maxCount === void 0 ? 0 : _conf$maxCount,
        _conf$space = conf.space,
        space = _conf$space === void 0 ? 0 : _conf$space,
        Component = conf.Component,
        _conf$animation = conf.animation,
        animation = _conf$animation === void 0 ? {} : _conf$animation,
        placement = conf.placement;
    _this.maxCount = maxCount;
    _this.Component = Component;
    _this.animation = animation;
    _this.placement = placement;
    _this.space = space;
    return _this;
  }

  _createClass(NotificationInstance, [{
    key: "setMounted",
    value: function setMounted(mounted) {
      this.mounted = mounted;
    }
  }, {
    key: "mount",
    value: function mount() {
      var placement = this.placement,
          mounted = this.mounted,
          space = this.space,
          disposed = this.disposed,
          Component = this.Component,
          animation = this.animation,
          container = this.container,
          getContainer = this.getContainer;

      if (container && !document.body.contains(container)) {
        document.body.appendChild(container);
      }

      if (mounted || disposed) {
        return;
      }

      this.mounted = true;
      var notifications = Object.keys(placement).map(function (key) {
        return React.createElement(RcNotificationContainer, {
          key: key,
          getContainer: getContainer,
          Component: Component,
          space: space,
          placement: key,
          position: placement[key],
          animation: animation[key],
          forceFixed: getContainer ? false : true
        });
      });
      ReactDOM.render(React.createElement(NotificationContext.Provider, {
        value: this
      }, notifications), container);
    }
  }, {
    key: "open",
    value: function open(notice, placement) {
      var _this2 = this;

      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : guid();
      var promise = new Promise(function (resolve) {
        var onClose = notice.onClose;

        var onNoticeClose = function onNoticeClose() {
          var removedNotice = _this2.removeNoticeByKey(key);

          if (removedNotice == null) {
            return;
          }

          onClose && onClose();
          resolve();

          _this2.emit('change', removedNotice.placement);
        };

        var needUpdatePlacementList = [placement];

        var currentNotice = _this2.removeNoticeByKey(key);

        if (currentNotice) {
          currentNotice.options.onClose && currentNotice.options.onClose();

          if (needUpdatePlacementList.indexOf(currentNotice.placement) < 0) {
            needUpdatePlacementList.push(currentNotice.placement);
          }
        }

        _this2.notices.push({
          options: notice,
          key: key,
          placement: placement,
          duration: duration,
          onClose: onNoticeClose
        });

        if (_this2.maxCount > 0 && _this2.notices.length > _this2.maxCount) {
          var removedNoticeList = _this2.notices.splice(0, _this2.notices.length - _this2.maxCount);

          removedNoticeList.forEach(function (item) {
            item.options.onClose && item.options.onClose();

            if (needUpdatePlacementList.indexOf(item.placement) < 0) {
              needUpdatePlacementList.push(item.placement);
            }
          });
        }

        needUpdatePlacementList.forEach(function (item) {
          _this2.emit('change', item);
        });

        _this2.mount();
      });

      var fn = function fn() {
        return _this2.close(key);
      };

      fn.then = function () {
        return promise.then.apply(promise, arguments);
      };

      fn.catch = function () {
        return promise.then.apply(promise, arguments);
      };

      return fn;
    }
  }, {
    key: "close",
    value: function close(key) {
      var notice = this.notices.find(function (item) {
        return item.key === key;
      });
      notice && notice.onClose();
    }
  }, {
    key: "setGetContainer",
    value: function setGetContainer(getContainer) {
      this.getContainer = getContainer;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this.mounted && this.container) {
        ReactDOM.unmountComponentAtNode(this.container);
        document.body.removeChild(this.container);
      }

      this.notices = [];
      this.disposed = true;
    }
  }, {
    key: "getNotices",
    value: function getNotices(placement) {
      return this.notices.filter(function (item) {
        return item.placement === placement;
      });
    }
  }, {
    key: "getIndexByNoticeKey",
    value: function getIndexByNoticeKey(key) {
      return this.notices.findIndex(function (item) {
        return item.key === key;
      });
    }
  }, {
    key: "removeNoticeByKey",
    value: function removeNoticeByKey(key) {
      var index = this.getIndexByNoticeKey(key);

      if (index < 0) {
        return null;
      }

      var _this$notices$splice = this.notices.splice(index, 1),
          _this$notices$splice2 = _slicedToArray(_this$notices$splice, 1),
          notice = _this$notices$splice2[0];

      return notice;
    }
  }]);

  return NotificationInstance;
}(Emitter);